import { PORTAL_GATEWAY_API_BASE_URL } from '../../config';
import { fetchWithSessionRefresh } from '../portalGatewayClient';

function aiAssistantDocumentDownloadUrl(
  documentId: string,
  inline: boolean
): URL {
  const url = new URL(
    `/portal-gateway/v1/tenant/ai/documents/${encodeURIComponent(documentId)}/download`,
    PORTAL_GATEWAY_API_BASE_URL.replace(/\/$/, '')
  );
  url.searchParams.set('inline', String(inline));
  return url;
}

export async function fetchAiAssistantDocumentPreviewUrl(
  documentId: string
): Promise<string> {
  const response = await fetchWithSessionRefresh(
    aiAssistantDocumentDownloadUrl(documentId, true),
    { method: 'GET' }
  );
  if (!response.ok) {
    throw new Error('Fetching the cited document failed.');
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}

export async function downloadAiAssistantDocument(
  documentId: string,
  fileName: string
): Promise<void> {
  const response = await fetchWithSessionRefresh(
    aiAssistantDocumentDownloadUrl(documentId, false),
    { method: 'GET' }
  );
  if (!response.ok) {
    throw new Error('Downloading the cited document failed.');
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  link.rel = 'noreferrer';
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
